import { Reducer } from "redux";
import { ActionTypes, ShiftActions } from "./ShiftActionTypes";
import { IShiftState, ShiftState } from "./ShiftState";

export const initialState: IShiftState = new ShiftState();

const reducer: Reducer<IShiftState> = (state: IShiftState = initialState, action: ShiftActions) => {
    switch (action.type) {
        case ActionTypes.HAS_AREA_SHIFTS_RETRIEVED:
            return { ...state, hasAreaShifts: action.hasAreaShifts };
        case ActionTypes.COMPANY_SHIFTS_RETRIEVED:
            return { ...state, companyShifts: action.companyShifts };
        case ActionTypes.AREA_SHIFTS_RETRIEVED:
            return { ...state, areaShifts: action.areaShifts };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/Shifts/ShiftReducer.ts